import React from "react";
import themePropTypes from "../theme-prop-types";

const MailOrderPharmacyAddress = ({ title, subtitle, onClick = () => {} }) => (
  <button
    type='button'
    className='mail-order-pharmacy-item-web-sdk'
    onClick={onClick}
  >
    <div className='mail-order-pharmacy-title-web-sdk'>{title}</div>
    <div className='mail-order-pharmacy-subtitle-web-sdk'>{subtitle}</div>
  </button>
);

MailOrderPharmacyAddress.propTypes = themePropTypes.mailOrderPharmacyAddress;

export default MailOrderPharmacyAddress;
